import {
  SET_SHAPE_FIELD,
  SET_WALL_PANEL_HEIGHT,
  SET_WALL_EDGING_STRIP_HEIGHT,
  SET_KITCHEN_ISLAND_MEASUREMENTS,
  SET_OVERHANG_FIELD,
  SET_FREESTANDING_HOB_WIDTH,
  SET_KITCHEN_ISLAND_OVERHANG_FIELD,
} from 'domain/Options/constants';
import { NO_KITCHEN_ISLAND_ID } from 'domain/Options/generators/kitchenIslands';
import * as planParameters from '../planParameters';

const nbrOrDefault = (nbr, def = null) => {
  const result = parseInt(nbr);
  return isNaN(result) ? def : result;
};

const setShapeField = (state, field, value) => {
  const selectedShapeId = state.getIn(['plan', planParameters.plannedShape, 'value', 'id']);
  return state.setIn(['shapeFields', selectedShapeId, field], nbrOrDefault(value));
};

export function setWallPanelHeight(state, height) {
  return state.setIn(['plan', planParameters.splashback, 'height'], nbrOrDefault(height));
}

export function setWallEdgingStripHeight(state, height) {
  return state.setIn(['plan', planParameters.wallEdgingStripCustomizable, 'height'], nbrOrDefault(height));
}

export function setKitchenIslandMeasurements(state, field, value) {
  const kitchenIslandId = state.getIn(['plan', planParameters.kitchenIsland, 'value', 'id']);
  if (kitchenIslandId === NO_KITCHEN_ISLAND_ID) {
    return state;
  }
  return state.setIn(['plan', planParameters.kitchenIsland, 'measurements', field], nbrOrDefault(value));
}

export function setOverhangField(state, field, value) {
  const selectedShapeId = state.getIn(['plan', planParameters.plannedShape, 'value', 'id']);
  const overhangId = state.getIn(['plan', planParameters.overhang, 'value', 'id']);
  const sideId = state.getIn(['plan', planParameters.overhangSide, 'value', 'id']);
  return state.setIn(['overhangFields', selectedShapeId, overhangId, sideId, field], nbrOrDefault(value));
}

export function setFreestandingHobWidth(state, field, value) {
  const def = state.getIn(['options', 'configuration', 'freestandingHobDefaultWidth']);
  return state.setIn(['plan', planParameters.freestandingHob, field], nbrOrDefault(value));
}

export function setKitchenIslandOverhangField(state, field, value) {
  const overhangId = state.getIn(['plan', planParameters.kitchenIslandOverhang, 'value', 'id']);
  const sideId = state.getIn(['plan', planParameters.kitchenIslandOverhangSide, 'value', 'id']);
  return state.setIn(['kitchenIslandOverhangFields', overhangId, sideId, field], nbrOrDefault(value));
}

function inputReducer(state, action) {
  switch (action.type) {
    case SET_OVERHANG_FIELD:
      return setOverhangField(state, action.field, action.value).setIn(['plan', 'lastAction'], action.type);
    case SET_KITCHEN_ISLAND_OVERHANG_FIELD:
      return setKitchenIslandOverhangField(state, action.field, action.value).setIn(['plan', 'lastAction'], action.type);
    case SET_SHAPE_FIELD:
      return setShapeField(state, action.field, action.value);
    case SET_WALL_PANEL_HEIGHT:
      return setWallPanelHeight(state, action.height).setIn(['plan', 'lastAction'], action.type);
    case SET_WALL_EDGING_STRIP_HEIGHT:
      return setWallEdgingStripHeight(state, action.height).setIn(['plan', 'lastAction'], action.type);
    case SET_KITCHEN_ISLAND_MEASUREMENTS:
      return setKitchenIslandMeasurements(state, action.field, action.value).setIn(['plan', 'lastAction'], action.type);
    case SET_FREESTANDING_HOB_WIDTH:
      return setFreestandingHobWidth(state, 'width', action.width).setIn(['plan', 'lastAction'], action.type);
    default:
      return state;
  }
}

export default inputReducer;
